import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mantine/core";
import Link from "next/link";

import { useTrackAnalytics } from "@/hooks/analytics.hooks";

export const VOICE_TRANSCRIPTION_DISCLAIMER =
  "Note: this response was transcribed from a recording and may contain errors";

/**
 * AS-2044: shown when `transcriptionFailureReason` is set — the audio can never
 * be transcribed and, since AS-2043, is no longer being retried. Distinct from
 * "Transcription pending...", which promises a transcript that is still coming.
 *
 * Deliberately not the vendor's error text ("Audio file is too short (HTTP 400
 * at whisper-transcription)"): that is diagnostic, not recruiter copy. It rides
 * the element's `title` so it stays one hover away without going on the page.
 */
export const VOICE_TRANSCRIPTION_UNAVAILABLE =
  "This recording could not be transcribed \u2014 play it to hear the answer";

interface VoiceAnswerLinkProps {
  href: string;
  label?: string;
  sessionId: string;
}

export const VoiceAnswerLink = ({
  href,
  label = "PLAY VOICE ANSWER",
  sessionId,
}: VoiceAnswerLinkProps) => {
  const track = useTrackAnalytics({ session_id: sessionId });

  return (
    <Button
      className="max-w-fit px-0"
      component={Link}
      href={href}
      onClick={() => track("Voice response played")}
      rel="noopener noreferrer"
      rightSection={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
      size="xs"
      target="_blank"
      variant="transparent"
    >
      {label}
    </Button>
  );
};
